/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Csat_GroupInputs */

const en_us2_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score from 1 to 5`)
};

const pt_br2_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota de 1 a 5`)
};

const es_419_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación del 1 al 5`)
};

const pt_pt2_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota de 1 a 5`)
};

const fr_fr2_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note de 1 à 5`)
};

const de_de2_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung von 1 bis 5`)
};

const it_it2_engagement_csat_group = /** @type {(inputs: Engagement_Csat_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voto da 1 a 5`)
};

/**
* | output |
* | --- |
* | "Score from 1 to 5" |
*
* @param {Engagement_Csat_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_csat_group = /** @type {((inputs?: Engagement_Csat_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Csat_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_csat_group(inputs)
	if (locale === "es-419") return es_419_engagement_csat_group(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_csat_group(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_csat_group(inputs)
	if (locale === "de-DE") return de_de2_engagement_csat_group(inputs)
	if (locale === "it-IT") return it_it2_engagement_csat_group(inputs)
	return en_us2_engagement_csat_group(inputs)
});
export { engagement_csat_group as "engagement.csat_group" }